export default __webpack_public_path__ + "static/media/capital-one.8d8052ff.png";